import { createContext, useContext } from 'react'

import type { AutoBidNotOrderedNotice } from '@ebalance/proto/bffuser/v1/auto_bid_notice_model_pb'

import type { SideMenuDot } from '~/models/sideMenuDot'

type SideMenuDotsValue = {
  /** メニュー項目の path → ドット。取得中・記録なし・取得失敗の間は空。 */
  dots: ReadonlyMap<string, SideMenuDot>
  /** 自動入札が発注しなかったコマの記録 (取得中・取得失敗の間は空)。 */
  autoBidNotOrderedNotices: readonly AutoBidNotOrderedNotice[]
}

const EMPTY: SideMenuDotsValue = {
  dots: new Map(),
  autoBidNotOrderedNotices: [],
}

/** Provider の外 (例: layout を持たない test) では「ドットなし・記録なし」。 */
export const SideMenuDotsContext = createContext<SideMenuDotsValue>(EMPTY)

/** サイドメニューの「path → ドット」(グループ・項目の描画が読む)。 */
export const useSideMenuDots = (): ReadonlyMap<string, SideMenuDot> =>
  useContext(SideMenuDotsContext).dots

/**
 * layout (`MainLayout`) が 1 か所で取得した「自動入札が発注しなかったコマの記録」を読む。
 * layout の内側の画面 (入札画面の警告バナー等) はこれを読む。`useQuery` の observer を
 * 増やさないので、30 秒の再取得は layout の 1 か所分のまま。
 */
export const useLayoutAutoBidNotOrderedNotices = (): {
  notices: readonly AutoBidNotOrderedNotice[]
} => ({ notices: useContext(SideMenuDotsContext).autoBidNotOrderedNotices })
